import { useApi } from '@backstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { notificationApiRef } from '../notificationApiRef';
import { NotificationBindingDeleteRequest } from '@agilelab/plugin-wb-notification-common';
import { WEBHOOKS_NOTIFICATIONS_KEY } from './reactQuery';

export const useDeleteNotificationBindings = (options?: {
  alertOnError?: boolean;
}) => {
  const notificationApi = useApi(notificationApiRef);
  const alertApi = useApi(customAlertApiRef);
  const queryClient = useQueryClient();

  const defaultOnSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [WEBHOOKS_NOTIFICATIONS_KEY] });
    alertApi.post({
      severity: 'success',
      message: 'Deletion successful',
    });
  };

  return useMutation({
    mutationFn: (request: NotificationBindingDeleteRequest) =>
      notificationApi.deleteNotificationBindings(request),
    onSuccess: defaultOnSuccess,
    onError: e => {
      if (options?.alertOnError === false) return;
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
